import React, { useContext } from "react";
import { Routes, Route } from "react-router-dom";

import { IcheerContext } from "../Context/AppContext";

import LoginPage from "../pages/Login";
import Register from "../pages/Register";
import Home from "../pages/Home";
import PasswordResetPage from "../pages/PasswordReset";
import AdminLoginPage from "../pages/AdminLogin";
import AdminHome from "../pages/AdminHome";

function Index() {
  const { isAdminLoggedIn, isSuperAdminLoggedIn } = useContext(IcheerContext)
  return (
    <div>

      <Routes>
        {isAdminLoggedIn && (
          <>
            <Route path="/" element={<Home />} />
          </>
        )}
        {isSuperAdminLoggedIn && (
          <>
            <Route path="/" element={<AdminHome />} />
          </>
        )}
        {!isAdminLoggedIn && !isSuperAdminLoggedIn && (
          <>
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<PasswordResetPage />} />
            <Route path="/admin-login" element={<AdminLoginPage />} />
          </>
        )}


      </Routes>
    </div>
  );
}

export default Index;
